import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import ListItem, { ListItemProps } from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

import { Item } from './typings';
import { colors } from 'src/themes/default';

const ListItemStyled = styled(ListItem)<ListItemProps>(({ theme }) => ({
    padding: '0px 5px 0px 10px',

    '&.isDraggingListItem': {
        background: colors.primary_D2,
        borderRadius: '5px',
    },
}));

export type DraggableListItemProps = {
    item: Item;
    index: number;
};

const DraggableListItem = ({ item, index }: DraggableListItemProps) => {
    return (
        <Draggable draggableId={item.id} index={index}>
            {(provided, snapshot) => (
                <ListItemStyled
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={snapshot.isDragging ? 'isDraggingListItem' : ''}
                >
                    <ListItemText>{item.element}</ListItemText>
                </ListItemStyled>
            )}
        </Draggable>
    );
};

export default DraggableListItem;
